class ReadingProgressService {
  constructor() {
    this.element = null;
    this.frame = null;
    this.discussionId = null;
    this.update = this.update.bind(this);
  }
  activate(discussion) {
    if (this.discussionId === discussion.id()) return;
    this.deactivate();
    this.discussionId = discussion.id();
    this.element = document.createElement('div');
    this.element.className = 'dc-reading-progress';
    this.element.setAttribute('role', 'progressbar');
    this.element.setAttribute('aria-label', 'Прогресс чтения');
    this.element.setAttribute('aria-valuemin', '0');
    this.element.setAttribute('aria-valuemax', '100');
    this.element.innerHTML = '<span></span>';
    document.body.appendChild(this.element);
    document.documentElement.classList.add('dc-reading-active');
    window.addEventListener('scroll', this.update, {
      passive: true
    });
    window.addEventListener('resize', this.update, {
      passive: true
    });
    this.update();
  }
  update() {
    if (this.frame !== null) return;

    // Один animation frame объединяет частые scroll-события и не заставляет браузер
    // пересчитывать геометрию страницы десятки раз за кадр.
    this.frame = window.requestAnimationFrame(() => {
      this.frame = null;
      const stream = document.querySelector('.DiscussionPage-stream');
      const firstBody = document.querySelector('.PostStream-item[data-number="1"] .Post-body, .PostStream-item:first-child .Post-body');
      if (!this.element || !stream || !firstBody) return;
      const start = firstBody.getBoundingClientRect().top + window.scrollY;
      const end = stream.getBoundingClientRect().bottom + window.scrollY - window.innerHeight;
      const distance = Math.max(1, end - start);
      const progress = Math.max(0, Math.min(1, (window.scrollY - start) / distance));
      const percent = Math.round(progress * 100);
      this.element.style.setProperty('--dc-reading-progress', `${percent}%`);
      this.element.setAttribute('aria-valuenow', String(percent));
    });
  }
  deactivate() {
    window.removeEventListener('scroll', this.update);
    window.removeEventListener('resize', this.update);
    if (this.frame !== null) window.cancelAnimationFrame(this.frame);
    this.element?.remove();
    document.documentElement.classList.remove('dc-reading-active');
    this.element = null;
    this.frame = null;
    this.discussionId = null;
  }
}
const readingProgress = new ReadingProgressService();
export default readingProgress;
flarum.reg.add('devconnect-articles', 'forum/service/ReadingProgressService', readingProgress);